export default __webpack_public_path__ + "static/media/exercises.901d079b.svg";